import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useCookies } from "react-cookie";
import selectedRangkBgImage from "../images/Impact_player_screen/home_screen/ranking_bg.png";
import rangkbgimage from "../images/Impact_player_screen/home_screen/Group_12509.png";
const ImpactPlayerLeaderboard = () => {
  const [cookies] = useCookies(["user"]);
  const [htmlData1, setHtmlData1] = useState([]);
  const [htmlData2, setHtmlData2] = useState([]);
  const [htmlData3, setHtmlData3] = useState([]);
  const user_id = cookies.user_id;
  const token = cookies.token;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            token: token,
            userId: user_id,
          },
          body: JSON.stringify({ dist_user_id: user_id }),
        };
        const response = await fetch(
          process.env.REACT_APP_BKB_URL_DOMAIN +
            "get-impact-warrior-leaderboard",
          requestOptions
        );
        const data = await response.json();
        console.log("API Impact Warrior Response:", data);
        getData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  /**
   * 
   * @param {*} text 
   * @returns {string}
   * @author Ajeet Yadav
   */
  function formatText(text) {
    const words = text.trim().split(/[^\w]+/).filter(Boolean);
    if (words.length > 2) {
        return words.slice(0, 2).join('.') + '...';
    } else {
        return text;
    }
  }
  function getData(data) {
    let html_1 = [];
    let html_2 = [];
    let html_3 = [];
    let html_4 = [];
    if (data.hasOwnProperty("leaders")) {
      data.leaders.forEach((leaders, index) => {
        if (leaders.rank === "1") {
          html_1.push(
            <div key={index} className="card-1">
              <span style={{fontWeight : "1000", fontSize : "16px"}}>1<sup style={{top:"0"}}>st</sup></span>
              <br />
              <span title={leaders.name}>{formatText(leaders.name)}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}} title={leaders.city}>{leaders.city}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}}>{leaders.company_name}</span>
              <br />
              <span style={{fontWeight : "600", fontSize : "15px"}}>
                <img
                  style={{}}
                  src={require("./../images/BKB-Elements/p1.svg").default}
                  alt="point-icon"
                  className="img-fluid"
                />&nbsp;
                {leaders.points}
              </span>
              <br />
              <span>
                <img
                  style={{ width: "50%", marginTop : "5px" }}
                  src={
                    require("./../images/Impact_player_screen/home_screen/mumbai.png")
                      .default
                  }
                  alt="point-icon"
                  className="img-fluid"
                />
              </span>
            </div>
          );
        } else if (leaders.rank === "2") {
          // leaders.name = "Ajeet Yadav Ghazipur Uttar Pradesh";
          html_2.push(
            <div key={index} className="card-2 margin-right">
                <span style={{fontWeight : "1000", fontSize : "16px"}}>2<sup style={{top:"0"}}>nd</sup></span>
              <br />
              <span title={leaders.name}>{formatText(leaders.name)}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}}>{leaders.city}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}}>{leaders.company_name}</span>
              <br />
              <span style={{fontWeight : "600", fontSize : "15px"}}>
                <img
                  style={{}}
                  src={require("./../images/BKB-Elements/p1.svg").default}
                  alt="point-icon"
                  className="img-fluid"
                />&nbsp;
                {leaders.points}
              </span>
              <br />
              <span>
                <img
                  style={{ width: "50%", marginTop : "5px" }}
                  src={
                    require("./../images/Impact_player_screen/home_screen/mumbai.png")
                      .default
                  }
                  alt="point-icon"
                  className="img-fluid"
                />
              </span>
            </div>
          );
        } else if (leaders.rank === "3") {
          html_3.push(
            <div key={index} className="card-2">
               <span style={{fontWeight : "1000", fontSize : "16px"}}>3<sup style={{top:"0"}}>rd</sup></span>
              <br />
              <span title={leaders.name}>{formatText(leaders.name)}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}}>{leaders.city}</span>
              <br />
              <span style={{opacity : "0.5", marginBottom : "2px"}}>{leaders.company_name}</span>
              <br />
              <span style={{fontWeight : "600", fontSize : "15px"}}>
                <img
                  style={{}}
                  src={require("./../images/BKB-Elements/p1.svg").default}
                  alt="point-icon"
                  className="img-fluid"
                />&nbsp;
                {leaders.points}
              </span>
              <br />
              <span>
                <img
                  style={{ width: "50%", marginTop : "5px" }}
                  src={
                    require("./../images/Impact_player_screen/home_screen/mumbai.png")
                      .default
                  }
                  alt="point-icon"
                  className="img-fluid"
                />
              </span>
            </div>
          );
        } else {
            
          let selectedRank = {};
          if (data.self.rank == leaders.rank && data.self.dist_user_id == leaders.dist_user_id ) {
            selectedRank.backgroundImage = `url(${selectedRangkBgImage})`;
            console.log(selectedRank);
          }
          html_4.push(
            <div key={index} className="row row-mrg-override margin-cont pl-3">
              <div className="w-15 position-relative">
                <div className="numWhtImgCont">
                  <div className={`numImg 15`}>{leaders.rank}</div>
                </div>
              </div>
              <div className="w-80  col-bluver bg-wht flt-lft pad-tb5-lr10" style={selectedRank}>
                <div className="w-65 flt-lft top-data">
                  <div className="top-title">{leaders.name}</div>
                  <div className="top-shop" style={{opacity : "0.5"}}>{leaders.city}</div>
                  <div className="top-shop" style={{opacity : "0.5"}}>{leaders.company_name}</div>
                </div>
                <div className="w-35 txt-rgt top-points top-points-2">
                  <span className="top-points-val">{leaders.points}</span>
                  <span className="top-points-img">
                      <img
                      style={{}}
                      src={require("./../images/BKB-Elements/p1.svg").default}
                      alt="point-icon"
                      className="img-fluid"
                    />
                  </span>
                </div>
              </div>
            </div>
          );
        }
      });
      setHtmlData1(html_1);
      setHtmlData2([html_2,html_3]);
      setHtmlData3(html_4);
    }
  }
  return (
    <>
      <Helmet link={
        [{"rel": "stylesheet", "href": 'css/leaderboard.css'}]
      }/>
      <div className="ip-ranking-card-1">{htmlData1}</div>
      <div className="ip-ranking-card-2">{htmlData2}</div>
      <div className="ip-ranking-card-3">
        {/* start */}
        {htmlData3}
        {/* end */}
      </div>
    </>
  );
};

export default ImpactPlayerLeaderboard;
